import { Plus } from "lucide-react"
import { Section, Eyebrow } from "./Section"
import { FAQS } from "./faqData"

export function Faq() {
  return (
    <Section>
      <div className="max-w-2xl">
        <Eyebrow>Questions</Eyebrow>
        <h2 className="display-2 mt-4">Frequently asked</h2>
      </div>

      <div className="mt-10 max-w-3xl divide-y divide-hairline border-y border-hairline">
        {FAQS.map((item) => (
          <details key={item.q} className="group py-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4">
              <h3>{item.q}</h3>
              <Plus className="h-5 w-5 shrink-0 text-ink-muted transition-transform group-open:rotate-45" />
            </summary>
            <p className="mt-3 text-ink-muted">{item.a}</p>
          </details>
        ))}
      </div>
    </Section>
  )
}
